<template>
	<div>
		<Form ref="formInline" :model="formInline" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="OperatorId">
				<Input style="width: 180px;" type="text" v-model="formInline.OperatorId" placeholder="运营商ID">
				<span slot="prepend">运营商ID</span>
				</Input>
			</FormItem>
			<FormItem prop="OperatorName">
				<Input style="width: 180px;" type="text" v-model="formInline.OperatorName" placeholder="运营商名称">
				<span slot="prepend">运营商名称</span>
				</Input>
			</FormItem>
			<FormItem prop="EvcsOperatorId">
				<Input style="width: 240px;" type="text" v-model="formInline.EvcsOperatorId" placeholder="互联互通运营商ID">
				<span slot="prepend">互联互通运营商ID</span>
				</Input>
			</FormItem>
			<FormItem prop="EvcsOperatorName">
				<Input style="width: 240px;" type="text" v-model="formInline.EvcsOperatorName" placeholder="互联互通运营商名称">
				<span slot="prepend">互联互通运营商名称</span>
				</Input>
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSubmit('formInline')" v-if="hasWidgets('search')">查询</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="show('add')" v-if="hasWidgets('add')">运营商添加</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">批量导入</Button> -->
			</div>
		</Form>
		<Table :columns="columns1" :data="data1" :height="tableHeight"></Table>
		<MyPage ref="sonPage" :param="pageParam" :url="getEvcsOperatorInfoUrl" @listData='getDeviceData'></MyPage>
		<Modal :mask-closable="false" v-model="modalView" :title="modal.Title" width="80%">
			<!--安装和修改-->
			<Form label-position="right" :rules="ruleInline"
				v-if="modal.type=='add'||modal.type=='update'||modal.type=='view'" ref="AddUpForm" :model="StationForm"
				:label-width="150">
				<Row>
					<Col :span="7">
					<FormItem v-show='false' label="Id标识" prop="Id">
						<Input :disabled="ifViewStation" v-model="StationForm.Id" placeholder="Id标识"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem v-show='false' label="上一级运营商" prop="UpperOperatorId">
						<Input :disabled="ifViewStation" v-model="StationForm.UpperOperatorId"
							placeholder="上一级运营商"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row style="margin-bottom: 10px;">
					<Col :span="7">
					<FormItem label="互联互通类型" prop="EvcsType">
						<Select :disabled="ifViewStation" placeholder="互联互通类型" v-model="StationForm.EvcsType">
							<Option :value='0'>标准互联互通</Option>
							<Option :value='1'>深圳发改委</Option>
							<Option :value='2'>国网重庆平台</Option>
							<Option :value='3'>南网平台</Option>
							<Option :value='4'>广西八桂充</Option>
							<Option :value='5'>海南一张网</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="互联互通标识" prop="EvcsId">
						<Input :disabled="modal.type != 'add'" v-model="StationForm.EvcsId"
							placeholder="留空表示随机生成, 8个字符, 与提供给对方网址相对应"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="支付模式" prop="PaymentMode">
						<Input :disabled="modal.type != 'add'" v-model="StationForm.PaymentMode"
							placeholder="支付模式取值100以上, 0表示在所有支付模式最大值加1"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row style="margin-bottom: 10px;">
					<Col :span="7">
					<FormItem label="是否启用" prop="Enable">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0'
							v-model="StationForm.Enable" size="large">
							<span slot="open">启用</span>
							<span slot="close">启用</span>
						</i-switch>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="是否推送" prop="EnablePush">
						<i-switch :disabled="ifViewStation" :true-value='1' :false-value='0'
							v-model="StationForm.EnablePush" size="large">
							<span slot="open">推送</span>
							<span slot="close">推送</span>
						</i-switch>
					</FormItem>
					</Col>
				</Row>
				<Divider orientation="left">本地运营商</Divider>
				<Row style="margin-bottom: 10px;">
					<Col :span="7" v-show='false'>
					<FormItem label="运营商ID" prop="LocalOperatorId">
						<Input :disabled="ifViewStation" v-model="StationForm.LocalOperatorId"
							placeholder="运营商ID"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="运营商名称" prop="LocalOperatorId">
						<Select placeholder="运营商名称" v-model="StationForm.LocalOperatorId">
							<Option v-bind:key="item.Id" v-for="(item) in typeList" :value="item.Id">{{item.Name}}
							</Option>
						</Select>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="运营商密钥" prop="LocalOperatorSecret">
						<Input :disabled="ifViewStation" v-model="StationForm.LocalOperatorSecret"
							placeholder="运营商密钥"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row style="margin-bottom: 10px;">
					<Col :span="7">
					<FormItem label="消息密钥" prop="LocalDataSecret">
						<Input :disabled="ifViewStation" v-model="StationForm.LocalDataSecret"
							placeholder="消息密钥"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="消息密钥初始化向量" prop="LocalDataSecretIv">
						<Input :disabled="ifViewStation" v-model="StationForm.LocalDataSecretIv"
							placeholder="消息密钥初始化向量"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="签名秘钥" prop="LocalSigSecret">
						<Input :disabled="ifViewStation" v-model="StationForm.LocalSigSecret"
							placeholder="签名秘钥"></Input>
					</FormItem>
					</Col>
				</Row>
				<Divider orientation="left">互联互通运营商</Divider>
				<Row>
					<Col :span="7">
					<FormItem label="运营商ID" prop="EvcsOperatorId">
						<Input :disabled="ifViewStation" v-model="StationForm.EvcsOperatorId"
							placeholder="运营商ID"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="运营商名称" prop="EvcsOperatorName">
						<Input :disabled="ifViewStation" v-model="StationForm.EvcsOperatorName"
							placeholder="运营商名称"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="运营商密钥" prop="EvcsOperatorSecret">
						<Input :disabled="ifViewStation" v-model="StationForm.EvcsOperatorSecret"
							placeholder="运营商密钥"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col :span="7">
					<FormItem label="消息密钥" prop="EvcsDataSecret">
						<Input :disabled="ifViewStation" v-model="StationForm.EvcsDataSecret"
							placeholder="消息密钥"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="消息密钥初始化向量" prop="EvcsDataSecretIv">
						<Input :disabled="ifViewStation" v-model="StationForm.EvcsDataSecretIv"
							placeholder="消息密钥初始化向量"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="签名秘钥" prop="EvcsSigSecret">
						<Input :disabled="ifViewStation" v-model="StationForm.EvcsSigSecret"
							placeholder="签名秘钥"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col :span="22">
						<FormItem label="接口地址" prop="EvcsUrl">
							<Input :disabled="ifViewStation" v-model="StationForm.EvcsUrl" placeholder="互联互通接口地址"></Input>
						</FormItem>
					</Col>
				</Row>
				<Row>
					<Col :span="7">
					<FormItem v-show='false' label="guid Token" prop="GuidToken">
						<Input :disabled="ifViewStation" v-model="StationForm.GuidToken"
							placeholder="guid Token"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem v-show='false' label="jwt  Token" prop="JwtToken">
						<Input :disabled="ifViewStation" v-model="StationForm.JwtToken"
							placeholder="jwt  Token"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col :span="7">
					<FormItem v-show='false' label="token 过期时间" prop="ExpireTime">
						<DatePicker :disabled="ifViewStation" type="datetime" v-model="StationForm.ExpireTime"
							placeholder="token 过期时间"></DatePicker>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem v-show='false' label="token 更新时间" prop="UpdateTime">
						<DatePicker :disabled="ifViewStation" type="datetime" v-model="StationForm.UpdateTime"
							placeholder="token 更新时间"></DatePicker>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem v-show='false' label="即将过期的 guid Token;" prop="GuidTokenDelay">
						<Input :disabled="ifViewStation" v-model="StationForm.GuidTokenDelay"
							placeholder="即将过期的 guid Token;"></Input>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col :span="7">
					<FormItem v-show='false' label="即将过期的 jwt Token" prop="JwtTokenDelay">
						<Input :disabled="ifViewStation" v-model="StationForm.JwtTokenDelay"
							placeholder="即将过期的 jwt Token"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem v-show='false' label="平滑过渡过期时间" prop="ExpireTimeDelay">
						<DatePicker :disabled="ifViewStation" type="datetime" v-model="StationForm.ExpireTimeDelay"
							placeholder="平滑过渡过期时间"></DatePicker>
					</FormItem>
					</Col>
				</Row>
				<Row>
					<Col :span="7">
					<FormItem v-show='false' label="推送token" prop="PushToken">
						<Input :disabled="ifViewStation" v-model="StationForm.PushToken" placeholder="推送token"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem v-show='false' label="推送token过期时间" prop="PushTokenExpireTime">
						<DatePicker :disabled="ifViewStation" type="datetime" v-model="StationForm.PushTokenExpireTime"
							placeholder="推送token过期时间"></DatePicker>
					</FormItem>
					</Col>
				</Row>
				<Divider></Divider>
				<Row>
					<Col :span="7">
					<FormItem label="备注" prop="Remark">
						<Input :disabled="ifViewStation" v-model="StationForm.Remark" placeholder="备注"></Input>
					</FormItem>
					</Col>
				</Row>
				<!-- <Row>
					<Col :span="7">
					<FormItem label="建档人Id" prop="CreateBy">
						<Input :disabled="ifAddStation" v-model="StationForm.CreateBy" placeholder="建档人Id"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="建档时间" prop="CreateTime">
						<Input :disabled="ifAddStation" v-model="StationForm.CreateTime" placeholder="建档时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
				<!-- <Row>
					<Col :span="7">
					<FormItem label="修改人Id" prop="ModifyBy">
						<Input :disabled="ifAddStation" v-model="StationForm.ModifyBy" placeholder="修改人Id"></Input>
					</FormItem>
					</Col>
					<Col :span="7">
					<FormItem label="修改时间" prop="ModifyTime">
						<Input :disabled="ifAddStation" v-model="StationForm.ModifyTime" placeholder="修改时间"></Input>
					</FormItem>
					</Col>
				</Row> -->
			</Form>
			<div v-if="modal.type=='add'" slot="footer">
				<Button v-if="modal.type!='install'" type="warning" size="large" @click="modalCancel">重置</Button>
				<Button type="success" size="large" @click="modalOk('add')">新增</Button>
			</div>
			<div v-if="modal.type=='update'" slot="footer">
				<Button type="success" size="large" @click="modalOk('up')">确认修改</Button>
			</div>
			<div v-if="modal.type=='view'" slot="footer">
			</div>
		</Modal>
	</div>
</template>

<script>
	import dateFormat from '../../../../public/js/comm.js'
	import Qs from 'qs'
	import {
		mapState,
		mapGetters,
		mapActions
	} from 'vuex'
	import webapi from '../../../webapi.js'
	export default {
		data() {
			const validateOpId = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('输入运营商Id'));
				} else {
					if (this.StationForm.EvcsOperatorId.length !== 9) {
						callback(new Error('输入社会信用代码码第9~倒数第2位'));
					}
					callback();
				}
			};
			return {
				getEvcsOperatorInfoUrl: webapi.base_api_url + '/Archives/GetEvcsOperatorInfo',
				zindex: 2000,
				loadingStatus: false,
				//model表单
				params: "", //table 传参
				// //选择展示的充电站
				// SelectStation: "有家充电站",
				tableHeight: "650",
				modal: {
					Title: "运营商添加",
					type: "addOperator"
				},
				//修改添加moda
				modalView: false,
				//图片modal
				showPictures: false,
				//图片上传组件数据
				defaultList: [],
				upHeader: {
					'Authorization': "Bearer " + encodeURIComponent(localStorage.AccessToken)
				},
				imgName: '',
				visible: false,
				uploadList: [],
				//新增图片删除缓存
				PictureDelCache: [],
				//原始图片删除缓存
				PictureUpCache: [],
				//图片地址数组
				StationPicturesArray: [],
				/******分割线********/

				//地图modal
				center: [114.198595, 22.633595],
				showMap: false,
				//字段显示
				ifAddStation: true,
				//场站信息是否只能查看
				ifViewStation: false,
				//档案-场站管理全部信息
				StationForm: {
					//Id标识	
					Id: 0,
					//互联互通类型	
					EvcsType: 0,
					//上一级运营商	
					UpperOperatorId: '',
					//本地运营商ID	
					LocalOperatorId: '',
					//本地运营商名称	
					LocalOperatorName: '',
					//本地运营商密钥	
					LocalOperatorSecret: '',
					//本地消息密钥	
					LocalDataSecret: '',
					//本地消息密钥初始化向量	
					LocalDataSecretIv: '',
					//本地签名秘钥	
					LocalSigSecret: '',
					//互联互通运营商ID	
					EvcsOperatorId: '',
					//互联互通运营商名称	
					EvcsOperatorName: '',
					//互联互通运营商密钥	
					EvcsOperatorSecret: '',
					//互联互通消息密钥	
					EvcsDataSecret: '',
					//互联互通消息密钥初始化向量	
					EvcsDataSecretIv: '',
					//互联互通签名秘钥	
					EvcsSigSecret: '',
					//互联互通接口地址	
					EvcsUrl: '',
					//guid Token	
					GuidToken: '',
					//jwt  Token	
					JwtToken: '',
					//token 过期时间	
					ExpireTime: '',
					//token 更新时间	
					UpdateTime: '',
					//即将过期的 guid Token; 用于平滑过渡	
					GuidTokenDelay: '',
					//即将过期的 jwt Token; 用于平滑过渡	
					JwtTokenDelay: '',
					//平滑过渡过期时间	
					ExpireTimeDelay: '',
					//是否启用	
					Enable: 0,
					//是否推送	
					EnablePush: 0,
					//推送token	
					PushToken: '',
					//推送token过期时间	
					PushTokenExpireTime: '',
					//备注	
					Remark: '',
					//建档人Id	
					CreateBy: 0,
					//建档时间	
					CreateTime: '',
					//修改人Id	
					ModifyBy: 0,
					//修改时间	
					ModifyTime: '',
					//支付模式	
					PaymentMode: 0
				},
				//校验字段
				ruleInline: {
					EvcsOperatorId: [{
						validator: validateOpId,
						trigger: 'blur',
					}],
					EvcsType: [{
						required: true,
						message: '互联互通类型',
						trigger: 'change',
						type: 'number'
					}],
					LocalOperatorId: [{
						required: true,
						message: '本地运营商ID',
						trigger: 'blur'
					}],
					LocalOperatorSecret: [{
						required: true,
						message: '本地运营商密钥',
						trigger: 'blur'
					}],
					LocalDataSecret: [{
						required: true,
						message: '本地消息密钥',
						trigger: 'blur',
					}],
					LocalDataSecretIv: [{
						required: true,
						message: '本地消息密钥初始化向量',
						trigger: 'blur',
					}],
					LocalSigSecret: [{
						required: true,
						message: '本地签名秘钥',
						trigger: 'blur',
					}],
					EvcsOperatorName: [{
						required: true,
						message: '互联互通运营商名称',
						trigger: 'blur',
					}],
					EvcsOperatorSecret: [{
						required: true,
						message: '互联互通运营商密钥',
						trigger: 'blur',
					}],
					EvcsDataSecret: [{
						required: true,
						message: '互联互通消息密钥',
						trigger: 'blur',
					}],
					EvcsDataSecretIv: [{
						required: true,
						message: '互联互通消息密钥初始化向量',
						trigger: 'blur',
					}],
					EvcsSigSecret: [{
						required: true,
						message: '互联互通签名秘钥',
						trigger: 'blur',
					}],
					EvcsUrl: [{
						required: true,
						message: '互联互通接口地址',
						trigger: 'blur',
					}],
				},
				BreadcrumbList: ['档案管理', '>>', '互联互通运营商'],

				formInline: {
					OperatorId: '',
					OperatorName: '',
					EvcsOperatorName: '',
					EvcsOperatorId: ''
				},

				//table标题数据
				columns1: [{
						title: '互联互通标识',
						key: 'EvcsId',
						minWidth: 120
					}, {
						title: '互联互通类型',
						key: 'EvcsType',
						minWidth: 120,
						render: (h, params) => {
							let typeDesc = ''
							switch (params.row.EvcsType) {
								case 0:
									typeDesc = '标准互联互通'
									break;
								case 1:
									typeDesc = '深圳发改委'
									break;
								case 2:
									typeDesc = '国网重庆平台'
									break;
								case 3:
									typeDesc = '南网平台'
									break;
								case 4:
									typeDesc = '广西八桂充'
									break;
								case 5:
									typeDesc = '海南一张网'
									break;
								default:
									typeDesc = '未定义'
									break;
							}
							return h('div', typeDesc)
						}
					},
					// {
					// 	title: '上一级运营商',
					// 	key: 'UpperOperatorId',
					// 	minWidth: 100
					// },
					{
						title: '本地运营商ID',
						key: 'LocalOperatorId',
						minWidth: 120
					},
					{
						title: '本地运营商名称',
						key: 'LocalOperatorName',
						minWidth: 120
					},
					{
						title: '本地运营商密钥',
						key: 'LocalOperatorSecret',
						minWidth: 120
					},
					{
						title: '本地消息密钥',
						key: 'LocalDataSecret',
						minWidth: 120
					},
					{
						title: '本地消息密钥初始化向量',
						key: 'LocalDataSecretIv',
						minWidth: 120
					}, {
						title: '本地签名秘钥',
						key: 'LocalSigSecret',
						minWidth: 120
					}, {
						title: '本地接口地址',
						key: 'LocalUrl',
						minWidth: 120,
						render: (h, params) => {
							return h('div', `https://域名/evcs/v1.0/${params.row.EvcsId}/`);
						}
					}, {
						title: '互联互通运营商ID',
						key: 'EvcsOperatorId',
						minWidth: 120
					}, {
						title: '互联互通运营商名称',
						key: 'EvcsOperatorName',
						minWidth: 120
					}, {
						title: '互联互通运营商密钥',
						key: 'EvcsOperatorSecret',
						minWidth: 120
					}, {
						title: '互联互通消息密钥',
						key: 'EvcsDataSecret',
						minWidth: 120
					}, {
						title: '互联互通消息密钥初始化向量',
						key: 'EvcsDataSecretIv',
						minWidth: 120
					}, {
						title: '互联互通签名秘钥',
						key: 'EvcsSigSecret',
						minWidth: 120
					}, {
						title: '互联互通接口地址',
						key: 'EvcsUrl',
						minWidth: 120
					},
					// {
					// 	title: 'guid Token',
					// 	key: 'GuidToken',
					// 	width: 100
					// }, {
					// 	title: 'jwt  Token',
					// 	key: 'JwtToken',
					// 	width: 100
					// }, {
					// 	title: 'token 过期时间',
					// 	key: 'ExpireTime',
					// 	width: 100
					// }, {
					// 	title: 'token 更新时间',
					// 	key: 'UpdateTime',
					// 	width: 100
					// }, {
					// 	title: '即将过期的 guid Token; 用于平滑过渡',
					// 	key: 'GuidTokenDelay',
					// 	width: 100
					// }, {
					// 	title: '即将过期的 jwt Token; 用于平滑过渡',
					// 	key: 'JwtTokenDelay',
					// 	width: 100
					// }, {
					// 	title: '平滑过渡过期时间',
					// 	key: 'ExpireTimeDelay',
					// 	width: 100
					// }, 
					{
						title: '是否启用',
						key: 'Enable',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.Enable == 1 ? '是' : '否')
						}
					}, {
						title: '是否推送',
						key: 'EnablePush',
						minWidth: 100,
						render: (h, params) => {
							return h('div', params.row.EnablePush == 1 ? '是' : '否')
						}
					},
					// {
					// 	title: '推送token',
					// 	key: 'PushToken',
					// 	width: 100
					// }, 
					// {
					// 	title: '推送token过期时间',
					// 	key: 'PushTokenExpireTime',
					// 	width: 100
					// }, 
					{
						title: '备注',
						key: 'Remark',
						minWidth: 100
					}, {
						title: '支付模式',
						key: 'PaymentMode',
						minWidth: 100,
					}, {
						title: '建档人Id',
						key: 'CreateBy',
						minWidth: 100
					}, {
						title: '建档时间',
						key: 'CreateTime',
						minWidth: 110
					}, {
						title: '修改人Id',
						key: 'ModifyBy',
						minWidth: 100
					}, {
						title: '修改时间',
						key: 'ModifyTime',
						minWidth: 110
					}, {
						title: '操作',
						key: 'action',
						minWidth: 200,
						align: 'center',
						render: (h, params) => {
							return h('div', [
								this.hasWidgets('edit') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										click: () => {
											this.show("update", params.row.Id)
										}
									}
								}, '修改') : h(),
								this.hasWidgets('view') ? h('Button', {
									props: {
										type: 'primary',
										size: 'small'
									},
									style: {
										marginRight: '5px'
									},
									on: {
										//为了不误操作，确定取消相反
										click: () => {
											this.show("view", params.row.Id)
										}
										// this.show("deleteStation", params.row.Id)
									}
								}, '查看') : h(),
								// h('Dropdown', {
								// 		on: {
								// 			//为了不误操作，确定取消相反
								// 			'on-click': (name) => {
								// 				this.$Modal.confirm({
								// 					title: name,
								// 					okText: '取消',
								// 					cancelText: '确定',
								// 					onCancel: () => {
								// 						this.otherMethodStation(name, params.row.Id);
								// 					}
								// 				});
								// 				// this.show("deleteStation", params.row.Id)
								// 			}
								// 		}
								// 	},
								// 	[
								// 		h('Button', {
								// 			props: {
								// 				type: 'primary',
								// 				size: 'small',
								// 			},
								// 			style: {
								// 				marginRight: '5px'
								// 			},
								// 		}, '其他操作'),
								// 		h('DropdownMenu', {
								// 			slot: 'list'
								// 		}, [
								// 			this.methodList.map((item) => { // this.productTypeList下拉框里的data
								// 				return h('DropdownItem', {
								// 						props: {
								// 							name: item.Status
								// 						}
								// 					},
								// 					item.Status
								// 				)
								// 			})
								// 		])
								// 	],
								// )
							]);
						}
					}
				],
				methodList: [{
						id: 1,
						Status: '建设中'
					}, {
						id: 5,
						Status: '关闭下线'
					},
					{
						id: 6,
						Status: '维护中'
					},
					{
						id: 50,
						Status: '正常使用'
					}
				],
				data1: [],
				payValue: 0
			};
		},
		created() {
			const _this = this;
			// _this.tableHeight = window.innerHeight - 220;
			this.getTableHeight();
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.handleSubmit();
			//this.uploadList = this.$refs.upload.fileList;
		},
		computed: {
			pageParam: function() {
				const _this = this;
				const param = {
					OperatorId: _this.formInline.OperatorId,
					OperatorName: _this.formInline.OperatorName,
					EvcsOperatorName: _this.formInline.EvcsOperatorName,
					EvcsOperatorId: _this.formInline.EvcsOperatorId
				}
				return param
			},

			//直接选属性
			...mapState({
				StationList: 'Stations',
				typeList: 'typeList',
				PaymentMode: 'PaymentMode'
			})
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			//操作
			show: function(type, params) {
				switch (type) {
					case "add":
						this.modal.type = "add";
						this.modal.Title = "互联互通运营商添加";
						this.ifViewStation = false
						this.modalView = true;
						this.modalCancel();
						break;
					case "update":
						this.modal.type = "update";
						this.modal.Title = "互联互通运营商信息修改";
						this.$nextTick(() => {
							this.getUpdateMessage(params);
						})
						this.modalView = true;
						this.ifViewStation = false
						break;
					case "view":
						this.modal.type = "view";
						this.modal.Title = "互联互通运营商信息查看";
						this.$nextTick(() => {
							this.getUpdateMessage(params);
						})
						this.modalView = true;
						this.ifViewStation = true
						break;
				}
				//this.modalView = true;
			},

			//删除修改之外的其他操作
			otherMethodStation: function(name, Id) {
				let typeNum = (this.methodList.filter(function(item, index, arr) {
					return item.Status == name
				})[0]).id
				console.log(typeNum)
				this.$axios.post(webapi.base_api_url + "/Archives/SetStationStatus2222", {
					Id: Id,
					Status: typeNum
				}).then(res => {
					if (res.data.code == 0) {
						this.$Message.info(name + '成功');
					}
				})
			},

			deleteStation: function() {
				const _this = this;
				_this.$axios.post(webapi.base_api_url + "/Overview/###", {}).then(res => {
					if (res.data.code != 1 && res.data.Data != null) {
						this.$Message.info('删除成功');
					}
				})
			},

			getDeviceData: function(data) {
				console.log(data)
				this.data1 = data.Data.List
			},


			handleSubmit: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},

			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220 - (window.innerWidth < 1168 ? 40 : 0);
			},

			modalCancel: function() {
				this.$nextTick(() => {
					this.$refs.AddUpForm.resetFields();
				})
			},
			getUpdateMessage: function(Id) {
				console.log("修改查看互联运营商方法Id" + Id);
				const _this = this;
				for (let i = 0; i < _this.data1.length; i++) {
					if (_this.data1[i].Id == Id) {
						_this.StationForm = Object.assign({}, _this.data1[i])
					}
				}
			},
			//新增||修改
			modalOk: function(type) {
				const _this = this
				switch (type) {
					case "add":
						_this.StationForm.Id = 0;
						break;
					case "up":
						break;
				}

				const param = _this.StationForm
				_this.$refs.AddUpForm.validate((valid) => {
					console.log("互联互通运营商" + type + "----" + valid)
					if (valid) {
						_this.$axios.post(webapi.base_api_url + '/Archives/AddEvcsOperator',
							param
						).then(res => {
							console.log(res)
							if (res.data.Code == 0) {
								_this.$Message.info("互联互通运营商" + type + "成功");
								_this.$refs.sonPage.getList();
								this.modalView = false;
							} else {
								_this.$Message.info("运营商" + type + "失败:" + res.data.Data);
							}
						})
					}
				})
			},
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */


	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 + .ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
